import { render } from "./FootSection.vue?vue&type=template&id=7efb8d3e&scoped=true"
const script = {}

import "./FootSection.vue?vue&type=style&index=0&id=7efb8d3e&scoped=true&lang=scss"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efb8d3e"]])

export default __exports__